import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Switch, Tooltip } from "antd";
import React from "react";
import { updatedAsset } from "../../../../store/actions/precog/assets";

export const columnsAssets = (
  registrationType, currentAccountDesc, groupedArticles, isSellingInvoice, dispatch, isUpdatedStopPlease, setIsUpdatedStopPlease
) => {  
  return  !isSellingInvoice ? [
    {
      title: registrationType === "article" ? <div>{currentAccountDesc}<br /><span style={{fontSize: "12px"}}>Conto contabile</span></div> : "cespiti",
      width: "20%",
      dataIndex: "cespite",
      key: "cespite"
    },
    {
      title: "Oneri accessori",
      width: "9%",
      dataIndex: "hasAdditionalCharge",
      key: "hasAdditionalCharge",
      render: (value, record) => {
        const isChecked = !!record.checkedArticles.find(el => el === record.key);                
        return (<div>
          {isUpdatedStopPlease ?
            <FontAwesomeIcon
              icon={["far", "circle-notch"]}
              spin
              style={{ color: "#0090d1", fontSize: "14px" }}
            />
            :
            <Tooltip placement="left" title={groupedArticles.length - record.additionChargeList.length <= 1 && !record.conto?.hasAdditionalCharge ? "Almeno un articolo tra quelli raggruppati non deve essere taggato come spesa accessoria" : ""} color={"rgb(0, 80, 117)"}>
              <Switch
                size="small"
                defaultChecked={!!record.conto?.hasAdditionalCharge}
                /** At least an article is not additionalCharge */
                disabled={(!record.conto.parentId && !isChecked) || ( groupedArticles.length - record.additionChargeList.length <= 1 && !record.conto?.hasAdditionalCharge) }
                onChange={() => {
                  setIsUpdatedStopPlease(true); 
                  dispatch(updatedAsset(record.key, 
                    { hasAdditionalCharge: !record.conto?.hasAdditionalCharge })).then(e => {
                    setIsUpdatedStopPlease(false);
                  });
                }
                } />
            </Tooltip>
          }
        
        </div>);
      }
    },
    {
      title: groupedArticles?.length > 0 ?
        <div style={{ display: "flex", width: "100%", marginRight: 8 }}>
          <div style={{ flexGrow: 1 }}>Nome cespite</div>
          <div style={{ color: "#5a6872" }}>Tot. cespite</div>
        </div> : "Nome cespite",
      align: "left",
      headerAlign: "left",
      width: "15%",
      dataIndex: "assetGroupName",
      key: "assetGroupName"
    },
    {
      title: "Sottospecie",
      align: "left",
      headerAlign: "left",
      width: "19%",
      dataIndex: "subKindDesc",
      key: "subKindDesc"
    },
    {
      title: "Criterio ammortamento fiscale",
      align: "left",
      headerAlign: "left",
      width: "17%",
      dataIndex: "fiscalCriteria",
      key: "fiscalCriteria"
    },
    {
      title: <span>Totale <FontAwesomeIcon icon={["fas", "info-circle"]} /></span>,
      align: "left",
      headerAlign: "left",
      width: "10%",
      dataIndex: "amount",
      key: "amout"
    },
    {
      title: "",
      width: "2%",
      dataIndex: "contoDetail",
      key: "contoDetail"
    }
  ] : [
    {
      title: registrationType === "article" ? <div>{currentAccountDesc}<br /><span style={{fontSize: "12px"}}>Conto contabile</span></div> : "cespiti",
      width: "20%",
      dataIndex: "cespite",
      key: "cespite"
    },
    {
      title: groupedArticles?.length > 0 ?
        <div style={{ display: "flex", width: "100%", marginRight: 8 }}>
          <div style={{flexGrow: 1}}>Nome cespite</div>
          <div style={{color: "#5a6872"}}>Tot. cespite</div>
        </div> : "Nome cespite",
      align: "left",
      headerAlign: "left",
      width: "15%",
      dataIndex: "assetGroupName",
      key: "assetGroupName"
    },
    {
      title: "Sottospecie",
      align: "left",
      headerAlign: "left",
      width: "20%",
      dataIndex: "subKindDesc",
      key: "subKindDesc"
    },
    {
      title: "Criterio ammortamento fiscale",
      align: "left",
      headerAlign: "left",
      width: "17%",
      dataIndex: "fiscalCriteria",
      key: "fiscalCriteria"    
    },
    {
      title: <span>Totale <FontAwesomeIcon icon={["fas", "info-circle"]} /></span>,
      align: "left",
      headerAlign: "left",
      width: "10%",
      dataIndex: "amount",
      key: "amout"
    },
    {
      title: "",
      width: "2%",
      dataIndex: "contoDetail",
      key: "contoDetail"
    }
  ];
};
